// extracted by mini-css-extract-plugin
export var section = "styles-module--section--39y-J";
export var title = "styles-module--title--1vCVS";
export var blocks = "styles-module--blocks--1bkaW";